module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.3eb01cd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_arrow_left.svg
// module id = 1197
// module chunks = 0